import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BenefitInvoice } from '@app/models/benefits/benefit-invoice.model';
import { BenefitProvider } from '@models/benefits/benefit-provider.model';
import { FileHelperService, NotifyService } from '@app/services';
import { Router } from '@angular/router';

const DEFAULT_ALLOWED_TYPES = ['.csv', '.xlsx'];

@Component({
    templateUrl: './benefit-invoice-store.template.html',
    styleUrls: ['./benefit-invoice-store.style.scss'],
})
export class BenefitInvoiceStoreView implements OnInit {
    benefitSettingsRoute = ['/', 'benefits', 'settings'];
    isLoading = false;

    benefitInvoice = new BenefitInvoice();
    invoiceFile!: File | null;
    benefitProviders!: BenefitProvider[];
    allowedFileTypes = DEFAULT_ALLOWED_TYPES;

    constructor(
        private fileHelper: FileHelperService,
        private notify: NotifyService,
        private router: Router
    ) {}

    async ngOnInit(): Promise<void> {
        this.isLoading = true;
        const [benefitProviders] = await BenefitProvider.where('isAllowedForInvoiceImport', 1)
            .orderBy('name', 'ASC')
            .all();

        this.benefitProviders = benefitProviders;

        this.isLoading = false;
    }

    onInvoiceUploaded(files: FileList): void {
        this.invoiceFile = files[0];
    }

    removeDocument(): void {
        this.invoiceFile = null;
    }

    benefitProviderUpdated(): void {
        this.allowedFileTypes = DEFAULT_ALLOWED_TYPES;
        const selectedProvider = this.benefitProviders.find(
            (provider) => provider.id === this.benefitInvoice.benefitProviderId
        );

        if (selectedProvider && selectedProvider.statementConfiguration) {
            const allowedType = '.' + selectedProvider.statementConfiguration.fileType;
            this.allowedFileTypes = [allowedType];

            if (!this.invoiceFile?.name.endsWith(allowedType)) {
                this.invoiceFile = null;
            }
        }
    }

    async save(form: NgForm): Promise<void> {
        form.onSubmit(null);

        if (!form.valid || !this.invoiceFile) {
            return;
        }

        this.isLoading = true;
        let invoice;

        try {
            invoice = await this.fileHelper.store(this.invoiceFile, 'benefitStatements');
        } catch (error) {
            this.notify.error(error);
            this.isLoading = false;
            return;
        }

        try {
            this.benefitInvoice.fileId = invoice.id;

            await this.benefitInvoice.save();

            this.notify.success('benefits.benefitsPayroll.benefitsStatementUploaded');
            this.router.navigate(['/benefits', 'settings', 'benefit-invoice', this.benefitInvoice.id]);
        } catch (error) {
            this.notify.error('benefits.benefitsPayroll.anErrorOccurred');
            this.isLoading = false;
        }
    }
}
